import React, { useEffect, useState, useRef } from "react";
import { aria } from './w3c_listbox';
const uniqid = require('uniqid');

const Listbox = (props) => {
	const {
		label = "",
		placeholder = "Bitte auswählen",
		options = [ "option1", "option2" ],
		selectedIndex = false,
		onChange, // will be called with selectedIndex as argument
		disabled = false,
		labelDisabled = "Nicht erlaubt",
	} = props;

	const [ id ] = useState(uniqid('listbox-'));
	const placeholderId = id + "-placeholder";
	const selectId = id + "-select";
	const optionsId = id + "-options";
	const selectRef = useRef(null);
	const optionsRef = useRef(null);
	const isSelected = selectedIndex !== false;

	useEffect(() => {
		new aria.ListboxButton(selectRef.current, new aria.Listbox(optionsRef.current));
		document.addEventListener('w3c_listbox_change', e => {
			if (e.detail.listboxNode === optionsRef.current) {
				const newIndex = JSON.parse(e.detail.values)[ 0 ];
				if (newIndex !== selectedIndex) {
					onChange(newIndex);
				}
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="listbox-area">
			<div className="left-area">
				<span className="exp_elem" id={ placeholderId }>{ label }</span>
				<div className="exp_wrapper">
					<button aria-haspopup="listbox"
						key={ 0 }
						aria-labelledby={ placeholderId + " " + selectId }
						id={ selectId } data-value={ isSelected ? "[\"" + selectedIndex + "\"]" : "" } className="exp_button"
						disabled={ disabled }
						aria-disabled={ disabled }
						ref={ selectRef }
						title={ disabled ? labelDisabled : null }
					>
						{ isSelected ? options[ selectedIndex ] : placeholder }
					</button>
					<ul tabIndex="-1" role="listbox" aria-labelledby={ placeholderId }
						key={ 1 }
						id={ optionsId } className="exp_elem_list hidden"
						ref={ optionsRef }
						aria-activedescendant={ isSelected ? (id + "-option-" + selectedIndex) : null }>
						{ options.map((val, key) =>
							<li role="option"
								id={ id + "-option-" + key }
								data-value={ key }
								key={ key }
								aria-selected={ selectedIndex === key }
								className={ selectedIndex === key ? "focused" : "" }
							>
								{ val }
							</li>
						) }
					</ul>
				</div>
			</div>
		</div>
	);
};

export default Listbox;
